import { Box, Typography } from "@mui/material";
import {
    subheadingSx,
    leaderboardCardSx,
    cyberColors,
    CYBER_FONT,
} from "../../styles/cyberTheme";

export default function CyberPanel({ title, children, sx = {}, contentSx = {} }) {
    return (
        <Box
            sx={{
                ...leaderboardCardSx,
                maxWidth: "none",
                height: "100%",
                display: "flex",
                flexDirection: "column",
                overflow: "hidden",
                boxSizing: "border-box",
                ...sx,
            }}
        >
            {title && (
                <Typography
                    sx={{
                        ...subheadingSx,
                        textAlign: "center",
                        py: 1,
                        borderBottom: `1px solid ${cyberColors.purple.borderMedium}`,
                        flexShrink: 0,
                    }}
                >
                    {title}
                </Typography>
            )}
            <Box
                sx={{
                    flex: 1,
                    overflow: "auto",
                    p: 1.5,
                    fontFamily: CYBER_FONT,
                    ...contentSx,
                }}
            >
                {children}
            </Box>
        </Box>
    );
}
